import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InventoryManagementRoutingModule } from './inventory-management-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    InventoryManagementRoutingModule
  ]
})
export class InventoryManagementModule { }
